
export type RegisterCardBody = {
  /** 카드 번호 (16자리) */
  cardNumber: string;
  /** 카드 비밀번호 앞 2자리 */
  cardPw: string;
  /** 유효기간 월 (2자리) */
  expiryMonth: string;
  /** 유효기간 년 (2자리) */
  expiryYear: string;
  /** 생년월일 (6자리, YYMMDD) */
  idNo: string;
};
